"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bluebird = require("bluebird");
var defaults = require("lodash/defaults");
var builder_1 = require("./builder");
var Util = require("./util");
var Quantizer = require("./quantizer");
var Generator = require("./generator");
var Filter = require("./filter");
var Vibrant = (function () {
    function Vibrant(_src, opts) {
        this._src = _src;
        this.opts = defaults({}, opts, Vibrant.DefaultOpts);
    }
    Vibrant.from = function (src) {
        return new builder_1.default(src);
    };
    Vibrant.prototype._process = function (image) {
        var _this = this;
        var opts = this.opts;
        var quantizer = opts.quantizer, generator = opts.generator;
        image.scaleDown(opts);
        var imageData = image.getImageData();
        return Bluebird.resolve(quantizer(imageData.data, opts))
            .then(function (colors) { return Bluebird.resolve(generator(colors)); })
            .tap(function (palette) { return _this._palette = palette; })
            .finally(function () { return image.remove(); });
    };
    Vibrant.prototype.palette = function () {
        return this.swatches();
    };
    Vibrant.prototype.swatches = function () {
        return this._palette;
    };
    Vibrant.prototype.getPalette = function (cb) {
        var _this = this;
        var image = new this.opts.ImageClass();
        return image.load(this._src)
            .then(function (image) { return _this._process(image); })
            .asCallback(cb);
    };
    return Vibrant;
}());
Vibrant.Builder = builder_1.default;
Vibrant.Quantizer = Quantizer;
Vibrant.Generator = Generator;
Vibrant.Filter = Filter;
Vibrant.Util = Util;
Vibrant.DefaultOpts = {
    colorCount: 64,
    quality: 5,
    generator: Generator.Default,
    ImageClass: null,
    quantizer: Quantizer.MMCQ,
    filters: [Filter.Default]
};
exports.default = Vibrant;
//# sourceMappingURL=vibrant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/node-vibrant/lib/vibrant.js
// module id = 457
// module chunks = 0